module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-7500-aca5415d.png";